import { render, staticRenderFns } from "./planInfo.vue?vue&type=template&id=18cb87e6"
import script from "./planInfo.vue?vue&type=script&lang=js"
export * from "./planInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cb87e6')) {
      api.createRecord('18cb87e6', component.options)
    } else {
      api.reload('18cb87e6', component.options)
    }
    module.hot.accept("./planInfo.vue?vue&type=template&id=18cb87e6", function () {
      api.rerender('18cb87e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/plan/planInfo.vue"
export default component.exports